import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const StarIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/star"><path id="Icon" d="M13.0417 3.46044C12.6564 2.53402 11.344 2.53402 10.9587 3.46044L8.76172 8.74256L3.05923 9.19973C2.05908 9.27991 1.65354 10.528 2.41554 11.1808L6.76024 14.9025L5.43287 20.4671C5.20006 21.4431 6.26179 22.2145 7.11806 21.6915L12.0002 18.7095L16.8823 21.6915C17.7386 22.2145 18.8003 21.4431 18.5675 20.4671L17.2401 14.9025L21.5848 11.1808C22.3468 10.528 21.9413 9.27991 20.9411 9.19973L15.2386 8.74256L13.0417 3.46044Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default StarIcon;